<script setup>
import { computed, watch } from "vue"
import { formatJson, validateJson } from "../utils/json_field"

const props = defineProps({
  modelValue: { type: String, default: "" },
  inputId: { type: String, required: true },
  inputName: { type: String, required: true },
  rows: { type: Number, default: 4 },
})

const emit = defineEmits(["update:modelValue", "validity-change"])

const validation = computed(() => validateJson(props.modelValue))

function updateValue(event) {
  emit("update:modelValue", event.target.value)
  emit("validity-change", validateJson(event.target.value).valid)
}

function formatValue() {
  try {
    const formatted = formatJson(props.modelValue)
    emit("update:modelValue", formatted)
    emit("validity-change", true)
  } catch {
    // Keep invalid value as-is
  }
}

watch(validation, (state) => {
  emit("validity-change", state.valid)
}, { immediate: true })
</script>

<template>
  <div class="json-field-editor">
    <textarea
      :id="inputId"
      :name="inputName"
      :value="modelValue"
      class="form-control json-field"
      :rows="rows"
      @input="updateValue"
    />
    <div class="json-field-actions">
      <button type="button" class="btn btn-sm btn-secondary" @click="formatValue">
        Format JSON
      </button>
      <span
        class="json-status"
        :class="{
          'json-status-valid': validation.valid && !validation.empty,
          'json-status-empty': validation.empty,
          'json-status-invalid': !validation.valid,
        }"
      >
        {{ validation.valid ? `✓ ${validation.message}` : `✗ ${validation.message}` }}
      </span>
    </div>
  </div>
</template>
